export const types = {
  // Async
  PRELOGIN_ASYNC: "PRELOGIN_ASYNC",
  LOGIN_ASYNC: "LOGIN_ASYNC",
  FORGOT_PASSWORD: "FORGOT_PASSWORD",
  REGISTER_ASYNC: "REGISTER_ASYNC",
  UPDATE_PROFILE_INFO_ASYNC: "UPDATE_PROFILE_INFO_ASYNC",
  FACEBOOK_LOGIN_ASYNC: "FACEBOOK_LOGIN_ASYNC",
  GOOGLE_LOGIN_ASYNC: "GOOGLE_LOGIN_ASYNC",
  APPLE_LOGIN_ASYNC: "APPLE_LOGIN_ASYNC",

  // Sync
  ENTER_PASSWORD: "ENTER_PASSWORD",
  RETURN_TO_LOGIN: "RETURN_TO_LOGIN",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
  UPDATE_PROFILE_INFO_SUCCEEDED: " UPDATE_PROFILE_INFO_SUCCEEDED",
  UPDATE_PROFILE_INFO_FAILED: " UPDATE_PROFILE_INFO_FAILED",
  START_LOADING: "START_LOADING",
  FINISH_LOADING: "FINISH_LOADING",
  IS_FIRST_POPUP_NEED: "IS_FIRST_POPUP_NEED",
};
